/* eslint-disable @animech/axiom/no-references-in-top-level-values */
/* eslint-disable @animech/axiom/strict-function-syntax */
import {
	makeArticles,
	makeProducts,
	makePropertyMeta,
} from "@animech/axiom-format/src/definitions/definition-bindings";
// eslint-disable-next-line @animech/axiom/no-unrelated-imports
import { cacheBustValueImages } from "../utility/cache-bust";
import { root } from "./property-definitions";
import { ALL_SIDES, SIDE_INDICES, type Side } from "./type-definitions";

export type CustomPropertyMeta = {
	//
};

export type CustomPropertyValueMeta = {
	//
};

export const currencies = ["sek", "eur", "usd"] as const;

export const productIds = [] as const;

export const products = makeProducts({
	items: {},
});

export const articles = makeArticles({
	categories: [],
	items: {},
});

// ---------------------------------------------------------------------------
// Shared theme value images (19 themes, reused for 7 theme properties)
// ---------------------------------------------------------------------------

const themeValueImages = cacheBustValueImages({
	"theme-none": {
		image: "images/themes/theme-none.svg",
		thumbnailImage: "images/themes/theme-none.svg",
	},
	"theme-teak-galvanized": {
		image: "images/themes/theme-teak-galvanized.svg",
		thumbnailImage: "images/themes/theme-teak-galvanized.svg",
	},
	"theme-teak-black": {
		image: "images/themes/theme-teak-black.svg",
		thumbnailImage: "images/themes/theme-teak-black.svg",
	},
	"theme-oak-galvanized": {
		image: "images/themes/theme-oak-galvanized.svg",
		thumbnailImage: "images/themes/theme-oak-galvanized.svg",
	},
	"theme-oak-black": {
		image: "images/themes/theme-oak-black.svg",
		thumbnailImage: "images/themes/theme-oak-black.svg",
	},
	"theme-pine-green": {
		image: "images/themes/theme-pine-green.svg",
		thumbnailImage: "images/themes/theme-pine-green.svg",
	},
	"theme-white-lacquer-galvanized": {
		image: "images/themes/theme-white-lacquer-galvanized.svg",
		thumbnailImage: "images/themes/theme-white-lacquer-galvanized.svg",
	},
	"theme-white-lacquer-black": {
		image: "images/themes/theme-white-lacquer-black.svg",
		thumbnailImage: "images/themes/theme-white-lacquer-black.svg",
	},
	"theme-green-galvanized": {
		image: "images/themes/theme-green-galvanized.svg",
		thumbnailImage: "images/themes/theme-green-galvanized.svg",
	},
	"theme-green-black": {
		image: "images/themes/theme-green-black.svg",
		thumbnailImage: "images/themes/theme-green-black.svg",
	},
	"theme-red-galvanized": {
		image: "images/themes/theme-red-galvanized.svg",
		thumbnailImage: "images/themes/theme-red-galvanized.svg",
	},
	"theme-red-black": {
		image: "images/themes/theme-red-black.svg",
		thumbnailImage: "images/themes/theme-red-black.svg",
	},
	"theme-hightech-white-galvanized": {
		image: "images/themes/theme-hightech-white-galvanized.svg",
		thumbnailImage: "images/themes/theme-hightech-white-galvanized.svg",
	},
	"theme-hightech-white-black": {
		image: "images/themes/theme-hightech-white-black.svg",
		thumbnailImage: "images/themes/theme-hightech-white-black.svg",
	},
	"theme-hightech-graphite-galvanized": {
		image: "images/themes/theme-hightech-graphite-galvanized.svg",
		thumbnailImage: "images/themes/theme-hightech-graphite-galvanized.svg",
	},
	"theme-hightech-graphite-black": {
		image: "images/themes/theme-hightech-graphite-black.svg",
		thumbnailImage: "images/themes/theme-hightech-graphite-black.svg",
	},
	"theme-hightech-galvanized": {
		image: "images/themes/theme-hightech-galvanized.svg",
		thumbnailImage: "images/themes/theme-hightech-galvanized.svg",
	},
	"theme-hightech-powdercoat-black": {
		image: "images/themes/theme-hightech-powdercoat-black.svg",
		thumbnailImage: "images/themes/theme-hightech-powdercoat-black.svg",
	},
	"theme-hightech-powdercoat-chestnut": {
		image: "images/themes/theme-hightech-powdercoat-chestnut.svg",
		thumbnailImage: "images/themes/theme-hightech-powdercoat-chestnut.svg",
	},
	"theme-hightech-powdercoat-ivory": {
		image: "images/themes/theme-hightech-powdercoat-ivory.svg",
		thumbnailImage: "images/themes/theme-hightech-powdercoat-ivory.svg",
	},
	"theme-hightech-powdercoat-petrol": {
		image: "images/themes/theme-hightech-powdercoat-petrol.svg",
		thumbnailImage: "images/themes/theme-hightech-powdercoat-petrol.svg",
	},
	"theme-libelle-green": {
		image: "images/themes/theme-libelle-green.svg",
		thumbnailImage: "images/themes/theme-libelle-green.svg",
	},
	"theme-libelle-grey": {
		image: "images/themes/theme-libelle-grey.svg",
		thumbnailImage: "images/themes/theme-libelle-grey.svg",
	},
	"theme-libelle-graphite": {
		image: "images/themes/theme-libelle-graphite.svg",
		thumbnailImage: "images/themes/theme-libelle-graphite.svg",
	},
});

// ---------------------------------------------------------------------------
// Shared seating type images
// ---------------------------------------------------------------------------

const chairTypeImages = cacheBustValueImages({
	"Chair-A2": {
		image: "images/chairs/Chair-A2.webp",
		thumbnailImage: "images/chairs/Chair-A2.webp",
	},
	"Chair-HighTech": {
		image: "images/chairs/Chair-HighTech.webp",
		thumbnailImage: "images/chairs/Chair-HighTech.webp",
	},
	"Chair-Bovik": {
		image: "images/chairs/Chair-Bovik.webp",
		thumbnailImage: "images/chairs/Chair-Bovik.webp",
	},
	"Chair-Libelle": {
		image: "images/chairs/Chair-Libelle.webp",
		thumbnailImage: "images/chairs/Chair-Libelle.webp",
	},
	"Chair-1": {
		image: "images/chairs/Chair-1.webp",
		thumbnailImage: "images/chairs/Chair-1.webp",
	},
});

const seatingTypeImages = {
	...chairTypeImages,
	...cacheBustValueImages({
		"Bench-8": {
			image: "images/benches/Bench-8.webp",
			thumbnailImage: "images/benches/Bench-8.webp",
		},
		"Bench-9": {
			image: "images/benches/Bench-9.webp",
			thumbnailImage: "images/benches/Bench-9.webp",
		},
		"Bench-Libelle": {
			image: "images/benches/Bench-Libelle.webp",
			thumbnailImage: "images/benches/Bench-Libelle.webp",
		},
		"Sofa-3": {
			image: "images/sofas/Sofa-3.webp",
			thumbnailImage: "images/sofas/Sofa-3.webp",
		},
		"Sofa-5": {
			image: "images/sofas/Sofa-5.webp",
			thumbnailImage: "images/sofas/Sofa-5.webp",
		},
	}),
} as const;

// ---------------------------------------------------------------------------
// Per-side metadata for product meta generation
// ---------------------------------------------------------------------------

function sideThemeKey(side: Side): string {
	return side === "round" ? "chairTheme" : `${side}ChairTheme`;
}

function sideChairTypeKey(side: Side): string {
	return side === "round" ? "chairType" : `${side}ChairType`;
}

// ---------------------------------------------------------------------------
// Generated propertyMeta entries from side iteration
// ---------------------------------------------------------------------------

const perSideThemeMeta = Object.fromEntries(
	ALL_SIDES.map((side) => [
		sideThemeKey(side),
		{
			property: root.chair[SIDE_INDICES[side]].chairTheme,
			values: themeValueImages,
		},
	]),
);

const perSideChairTypeMeta = Object.fromEntries(
	ALL_SIDES.map((side) => {
		const isLong = side === "top" || side === "bottom";
		return [
			sideChairTypeKey(side),
			{
				property: root.chair[SIDE_INDICES[side]].chairType,
				values: isLong ? seatingTypeImages : chairTypeImages,
			},
		];
	}),
);

// ---------------------------------------------------------------------------
// Property meta definition
// ---------------------------------------------------------------------------

const tableTypeValueImages = cacheBustValueImages({
	"Table-B31-84": {
		image: "images/tables/Table-B31-84.webp",
		thumbnailImage: "images/tables/Table-B31-84.webp",
	},
	"Table-B31-170": {
		image: "images/tables/Table-B31-170.webp",
		thumbnailImage: "images/tables/Table-B31-170.webp",
	},
	"Table-B31-230": {
		image: "images/tables/Table-B31-230.webp",
		thumbnailImage: "images/tables/Table-B31-230.webp",
	},
	"Table-6B-60": {
		image: "images/tables/Table-6B-60.webp",
		thumbnailImage: "images/tables/Table-6B-60.webp",
	},
	"Table-9A-100": {
		image: "images/tables/Table-9A-100.webp",
		thumbnailImage: "images/tables/Table-9A-100.webp",
	},
	"Table-9A-120": {
		image: "images/tables/Table-9A-120.webp",
		thumbnailImage: "images/tables/Table-9A-120.webp",
	},
	"Table-B25A-120": {
		image: "images/tables/Table-B25A-120.webp",
		thumbnailImage: "images/tables/Table-B25A-120.webp",
	},
	"Table-HighTech-60": {
		image: "images/tables/Table-HighTech-60.webp",
		thumbnailImage: "images/tables/Table-HighTech-60.webp",
	},
	"Table-HighTech-110": {
		image: "images/tables/Table-HighTech-110.webp",
		thumbnailImage: "images/tables/Table-HighTech-110.webp",
	},
	"Table-Libelle-140": {
		image: "images/tables/Table-Libelle-140.webp",
		thumbnailImage: "images/tables/Table-Libelle-140.webp",
	},
	"Table-Libelle-70": {
		image: "images/tables/Table-Libelle-70.webp",
		thumbnailImage: "images/tables/Table-Libelle-70.webp",
	},
	"Table-Bovik-150": {
		image: "images/tables/Table-Bovik-150.webp",
		thumbnailImage: "images/tables/Table-Bovik-150.webp",
	},
});

export const propertyMeta = makePropertyMeta({
	tableType: {
		property: root.tableType,
		values: tableTypeValueImages,
	},
	...perSideChairTypeMeta,
	materialTheme: {
		property: root.materialTheme,
		values: themeValueImages,
	},
	tableTheme: {
		property: root.tableTheme,
		values: themeValueImages,
	},
	...perSideThemeMeta,
});
